// src/knowledge/KnowledgeIcon.tsx
import * as React from "react";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import PictureAsPdfOutlined from "@mui/icons-material/PictureAsPdfOutlined";
import TableChartOutlined from "@mui/icons-material/TableChartOutlined";
import LinkOutlined from "@mui/icons-material/LinkOutlined";
import PsychologyOutlined from "@mui/icons-material/PsychologyOutlined";
import { SvgIconProps } from "@mui/material";

export default function KnowledgeIcon({
  type,
  ...props
}: { type: string } & SvgIconProps) {
  if (type === "TEXT") return <DescriptionOutlinedIcon {...props} />;
  if (type === "QUIP") return <InsertDriveFileIcon {...props} />;
  if (type === "PDF") return <PictureAsPdfOutlined {...props} />;
  if (type === "CSV") return <TableChartOutlined {...props} />;
  if (type === "URL") return <LinkOutlined {...props} />;
  return <PsychologyOutlined {...props} />;
}
